import MuiTooltip, { TooltipProps as MUITooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { readableColor } from 'polished';
import React from 'react';
export type TooltipProps = MUITooltipProps & {
  backgroundColor?: string;
  color?: string;
  boxShadow?: string;
  maxWidth?: number;
  font?: string;
  borderRadius?: string;
};
const StyledTooltip = styled(({
  className,
  ...props
}: TooltipProps) => <MuiTooltip {...props} classes={{
  popper: className
}} />)(({
  backgroundColor = '#273240',
  color,
  boxShadow = '0px 0px 10px #0000004D',
  maxWidth,
  font = 'normal normal bold 11px/15px',
  borderRadius = '4px'
}) => ({
  [`& .${tooltipClasses?.tooltip}`]: {
    backgroundColor,
    color: color || readableColor(backgroundColor) || '#fff',
    boxShadow,
    maxWidth,
    font,
    borderRadius
  },
  [`& .${tooltipClasses?.arrow}`]: {
    color: backgroundColor
  }
}));
export default StyledTooltip;